<template>
    <div
        :class="{
            'filter-toggle': true,
            'open': this.open
        }"
    >
        <button
            :class="{
                'filter-toggle__button' : true,
                'open': this.open
            }"
            @click.prevent.stop="toggle"
        >
            <span v-text="open ? 'Hide Filters' : 'Show Filters'" />
            <svg><path d="M4.95 2L1 7h8L4.95 2z" /></svg>
        </button>
        <div class="filter-toggle__content">
            <div class="toolbar">
                <fieldset class="toolbar__filters">
                    <div class="flex-fix">
                        <slot />
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FilterToggle',
    props: {},
    data: () => ({
        open: true
    }),
    methods: {
        toggle() {
            this.open = !this.open;
        }
    }
}
</script>
<style scoped lang="scss">
@import '~@/theme/_variables.scss';

.filter-toggle {
    margin-bottom: 2rem;
    margin-top: -.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    .filter-toggle__button {
        -webkit-appearance: none;
        appearance: none;
        background-color: transparent;
        border: none;
        display: flex;
        align-items: center;
        column-gap: .6rem;
        color: $accent;
        font-family: Axiforma, sans-serif;
        font-weight: 500;
        padding: 0;
        cursor: pointer;

        span {

        }

        svg {
            height: 1rem;
            width: 1rem;
            fill: $accent;
            transform: rotate(180deg);
        }

        &.open {
            svg {
                transform: rotate(0);
            }
        }
    }

    .filter-toggle__content {
        display: none;
    }

    &.open {
        .filter-toggle__content {
            display: block;
            padding-top: 1rem;
        }
    }
}
</style>
